<template>
    <div class="form-user">
        <mu-paper :z-depth="1">

            <mu-form :model="form">

                <mu-row gutter>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- Nome -->
                        <mu-text-field v-model.trim="form.firstName" full-width label="Nome *"></mu-text-field>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- Sobrenome -->
                        <mu-text-field v-model.trim="form.lastName" full-width label="Sobrenome *"></mu-text-field>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- E-mail -->
                        <mu-text-field v-model.trim="form.email" type="email" full-width label="E-mail *"></mu-text-field>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- Username -->
                        <mu-text-field v-model.trim="form.userName" full-width :disabled="userNameDisabled" label="Login *"></mu-text-field>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- Senha -->
                        <mu-text-field v-model.trim="form.password" type="password" @focus="verifyFocus()" @blur="verifyFocus()" full-width label="Senha *"></mu-text-field>
                        <small class="info-form" v-if="passFocus">A senha deve ter pelo menos 6 caracteres e ser composta por letras maiúsculas, minúsculas e números!</small>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- Confirmar Senha -->
                        <mu-text-field v-model.trim="form.passwordConfirmation" type="password" full-width label="Confirmar Senha *"></mu-text-field>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- Permition -->
                        <mu-select label="Permissão *" v-model="form.permition" full-width>
                            <mu-option v-for="(option, key) in options.roles" :key="key" :label="option.label" :value="option.value"></mu-option>
                        </mu-select>
                    </mu-col>
                    <mu-col span="12" sm="12" md="6" lg="6" xl="6">
                        <!-- Status -->
                        <mu-select label="Status *" v-model="form.status" full-width>
                            <mu-option v-for="(option, key) in options.status" :key="key" :label="option.label" :value="option.value"></mu-option>
                        </mu-select>
                    </mu-col>
                </mu-row>

                <!-- Salvar -->
                <mu-flex class="actions">
                    <mu-button round color="primary" @click="saveForm()" :disabled="validateForm">
                        <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                        Salvar
                    </mu-button>
                    <mu-button round :to="{ name: 'app.settings.users' }">
                        Cancelar
                    </mu-button>
                </mu-flex>

            </mu-form>

        </mu-paper>

        <br>

        <!-- Bloco para excluir -->
        <mu-paper class="cancel" :z-depth="1" v-if="type == 'edit'">

            <!-- Pergunta para excluir  -->
            <mu-row class="user-cost" justify-content="center" align-items="center">
                <mu-col span="12" sm="12" md="8" lg="8" xl="8">
                    <mu-flex class="title" justify-content="start" align-items="center">
                        <font-awesome-icon icon="exclamation-triangle" class="icon-md icon-margin-left color-red"/>
                        <strong>Excluir Usuário</strong>
                    </mu-flex>
                    O usuário depois de excluído não terá como recuperar.
                </mu-col>
                <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                    <div class="text-right">
                        <mu-button round color="error" @click="handleDialogDelete(true)">
                            <font-awesome-icon icon="trash" class="icon-md icon-margin-left"/>
                            Excluir
                        </mu-button>
                    </div>
                </mu-col>
            </mu-row>

            <!-- Dialogo para confirmar exclusão de campanha -->
            <mu-dialog title="Excluir usuário" width="600" max-width="80%" :esc-press-close="false" :overlay-close="false" :open.sync="cancel.openDelete">
                Tem certeza que deseja excluir o usuário <strong>{{ form.name }}</strong>
                <mu-button slot="actions" round @click="handleDialogDelete(false)">Cancelar</mu-button>
                <mu-button slot="actions" round color="error" @click="deleteForm()">
                    <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                    Confirmar
                </mu-button>
            </mu-dialog>

        </mu-paper>

    </div>
</template>

<script>
    import UsersServices from '@/services/settings/users'

    export default {
        name: 'mu-form-user',
        props: ['type'],

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    roles: [
                        { label: 'Admin', value: 'A' },
                        { label: 'Comercial', value: 'C' },
                        { label: 'Usuário', value: 'U' }
                    ],
                    status: [
                        { label: 'Inativo', value: 'I' },
                        { label: 'Ativo', value: 'A' }
                    ]
                },
                form: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    userName: '',
                    passwordHash: '',
                    permition: 'U',
                    shortcuts: '',
                    status: 'A'
                },
                cancel: {
                    openDelete: false
                },
                passFocus: false
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Retorna os dados do usuário salvos no state
             */
            user () {
                return this.$store.state.user
            },

            company () {
                return this.$store.state.company
            },

            /**
             * Verifica se a ação é editar ou não, usado para deixar editar ou não o campo login
             */
            userNameDisabled () {
                return this.type === 'edit'
            },

            /**
             * Validação de dados para formulário cadastrar / editar
             */
            validateForm () {
                if (this.type === 'edit') {
                    return !this.form.firstName || !this.form.lastName || !this.form.email || !this.form.userName
                }
                return !this.form.firstName || !this.form.lastName || !this.form.email || !this.form.userName || !this.form.password || !this.form.passwordConfirmation
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        /**
         * Se a ação for 'edit' já devemos chamar o loadForm() para carregar os dados do usuário
         */
        mounted () {
            if (this.type === 'edit') {
                this.loadForm()
            }
            if (this.user.permition === 'S') {
                this.options.roles.push({ label: 'Super', value: 'S' })
            }
            if (this.company.customType !== 'R') {
                this.options.roles = this.options.roles.filter((item) => {
                    return item.value !== 'C'
                })
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {
            verifyFocus () {
                this.passFocus = !this.passFocus
            },

            /**
             * Responsavel por habilitar o dialogo que exclui o usuário
             */
            handleDialogDelete (value) {
                this.cancel.openDelete = value
            },

            /**
             * Carrega os dados do usuário e mostra no formulário
             */
            async loadForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando os dados do usuário.')

                    this.form = {}

                    let result = await UsersServices.find(this.$route.params.id)

                    if (result && result.status) {
                        this.form = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Salva os dados do usuário
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Salvando os dados do usuário.')

                    let result
                    if (this.type === 'edit') {
                        result = await UsersServices.update(this.form)
                    } else {
                        result = await UsersServices.store(this.form)
                    }

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.settings.users' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar o usuário.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Responsavel por excluir o usuário
             */
            async deleteForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde, o usuário está sendo excluído.')

                    let result = await UsersServices.destroy(this.form.id)

                    if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.settings.users' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível excluir o usuário.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            }
        }
    }
</script>

<style lang="stylus" scoped>
    .info-form
        color $primary
        font-size 11px
        margin-top 5px

    .form-user
        margin 20px 0

        .actions
            .mu-button
                margin-right 5px

        .mu-paper
            padding 20px

        .cancel
            background lighten(#F44336, 92%)
            padding 20px
            color #999
            border 1px #F44336 dotted

            .title
                i
                    font-size 18px !important
                    color #F44336
                strong
                    font-size 16px
                    padding-left 5px
                    color #F44336

            .text-center
                text-align center

            .text-right
                text-align right

</style>
